import React, {Component, PropTypes} from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import moment from 'moment'

class Book extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIsbn: ''
    }
  }

  componentDidMount() {}

  render() {
    const {
      author,
      cover,
      isbn,
      onClick,
      path,
      publicationDate,
      rating,
      readingTime,
      readOn,
      supports3d,
      title
      // url
    } = this.props
    // console.log(url)
    //const isSelected= this.state.selectedIsbn === isbn;
    //const figureCssClass = isSelected? 'details-open':'';
    const figureCssClass = ''
    const injectedStyle = `
      .no-csstransforms3d .book[data-book="book-${isbn}"],
      .no-js .book[data-book="book-${isbn}"],
      .book[data-book="book-${isbn}"] .front {
            background-size: cover !important ;
            background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0.1) 0%, rgba(211, 211, 211, 0.1) 5%, rgba(255, 255, 255, 0.15) 5%, rgba(255, 255, 255, 0.1) 9%, rgba(0, 0, 0, 0.01) 100%), url(/images/${isbn}.jpg) no-repeat center,  #009bdb;
            background: linear-gradient(to right, rgba(0, 0, 0, 0.1) 0%, rgba(211, 211, 211, 0.1) 5%, rgba(255, 255, 255, 0.15) 5%, rgba(255, 255, 255, 0.1) 9%, rgba(0, 0, 0, 0.01) 100%), url(/images/${isbn}.jpg) no-repeat center, #009bdb;
          }

          .book[data-book="book-${isbn}"] .inner { border-color: #009bdb }
          .book[data-book="book-${isbn}"] .book-left {
            background: -webkit-linear-gradient(left, transparent 0%, rgba(0, 0, 0, 0.01) 1%, rgba(0, 0, 0, 0.1) 50%, transparent 100%), #009bdb;
            background: linear-gradient(to right, transparent 0%, rgba(0, 0, 0, 0.01) 1%, rgba(0, 0, 0, 0.1) 50%, transparent 100%), #009bdb;
          }`
    const bookHtml = supports3d ? (
      <div className="perspective">
        <div className="book" data-book={`book-${isbn}`}>
          <div className="cover">
            <div className="book-left">
              <h2>
                <span>{title}</span>
              </h2>
            </div>
            {/* <div className="front">
              <div className="inner inner-left" />
            </div> */}
            <Img sizes={cover.children[0].sizes} />
          </div>
          <div className="inner inner-right" />
        </div>
      </div>
    ) : (
      <div className="book" data-book={`book-${isbn}`} />
    )

    return (
      <figure className={figureCssClass} key={isbn}>
        <style dangerouslySetInnerHTML={{__html: injectedStyle}} />
        {bookHtml}
        <figcaption>
          <h2>
            {title}
            {/* <span>{author}</span> */}
          </h2>
        </figcaption>
        <div className="details">
          <ul>
            <li>
              <div className="buttons">
                {/* <Link data-hover="Read Notes" to={prefixLink(path)}> */}
                <Link
                  data-hover="Read Notes"
                  to={path}
                  onClick={this.props.onClick}
                >
                  Read Notes
                </Link>
              </div>
            </li>
            <li>Rating: {rating}/10</li>
            {/* <li>Reading Time: {readingTime} hours</li> */}
            {/* <li>Read On: {moment(readOn).format('MMM D, YYYY')}</li> */}
            <li>
              Author{author && author.indexOf(',') > -1 ? 's' : ''}: {author}
            </li>
            <li>Isbn: {isbn}</li>
          </ul>
        </div>
      </figure>
    )
  }
}

Book.propTypes = {
  author: PropTypes.string.isRequired,
  isbn: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  // publicationDate: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  // readOn: PropTypes.string.isRequired,
  // readingTime: PropTypes.number.isRequired,
  supports3d: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired
  // url: PropTypes.string.isRequired
  // onClick: PropTypes.function.isRequired
}

export default Book



// WEBPACK FOOTER //
// ./src/components/Book/Book.js